import { DeviceFamily } from "@/data/model/Enums";
import type { ILoginProvider } from "@/data/model/User";

export class Formatter {
    public static deviceFamilyIcon(family: DeviceFamily): string {
        switch (family) {
            case DeviceFamily.Android:
                return '<i class="la la-android"></i>';
            case DeviceFamily.Ios:
                return '<i class="la la-apple"></i>';
            case DeviceFamily.Pc:
                return '<i class="la la"></i>';
            case DeviceFamily.Other:
                return '<i class="la la-mobile"></i>';
        }

        return '<i class="la la-question"></i>';
    }

    public static providerLink(provider: ILoginProvider): string {
        switch (provider.loginProvider.toLowerCase()) {
            case "facebook":
                return (
                    '<a class="facebook" href="https://facebook.com/profile.php?id=' +
                    provider.providerKey +
                    '" target="_blank"><i class="fab fa-facebook-f"></i></a>'
                );
            case "linkedin":
                return (
                    '<a class="linkedin"  href="https://www.linkedin.com/in/' +
                    provider.providerKey +
                    '" target="_blank"><i class="fab fa-linkedin-in"></i></a>'
                );
            case "google":
                return '<a class="google" href="#"><i class="fab fa-google"></i></a>';
        }

        return '<a href="#"><i class="la la-question"></i></a>';
    }
}
